import { queryOptions } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";
import { V3SchoolThroughSchoolAdminResponse } from "./queries.type";

export const schoolAdminQueries = {
  all: () => [ApiCatalog.schoolAdmin.key] as const,
  schools: () =>
    queryOptions({
      queryKey: [
        ...schoolAdminQueries.all(),
        ApiCatalog.schoolThroughSchoolAdmin.key,
      ],
      queryFn: () =>
        api().get<V3SchoolThroughSchoolAdminResponse>(
          ApiCatalog.schoolThroughSchoolAdmin.endpoint.replace("[id]", "me"),
        ),
    }),
};
